import { Divider, Text, VStack } from '@chakra-ui/react'
import { useEffect, useMemo, useState } from 'react'

import { DetailField } from '../../../components/DetailField'
import { LoadingBlock } from '../../../components/Loading'
import { formatApiDate, useAppToast } from '../../../helpers'
import { IFullStep, IPersonnelMovementRequest } from '../../../services/PersonnelMovementRequests/interfaces'
import PersonnelMovementRequestsService from '../../../services/PersonnelMovementRequests/PersonnelMovementRequestsService'
import { ISector } from '../../../services/Sector/SectorService'

interface IAnswer {
  id: number
  value: string
  question_id: number
  request_id: number
}

export default function PersonnelMovementRequestViewPage({
  personnelMovementRequestId: id,
  sectors
}: {
  personnelMovementRequestId: number
  sectors: ISector[]
}) {
  const personnelMovementRequestsService = useMemo(() => new PersonnelMovementRequestsService(), [])
  const [personnelMovementRequest, setPersonnelMovementRequest] = useState<IPersonnelMovementRequest>()
  const [answers, setAnswers] = useState<IAnswer[]>([])
  const [steps, setSteps] = useState<IFullStep[]>([])
  const toast = useAppToast()

  const fetchPersonnelMovementRequest = async () => {
    try {
      const response = await personnelMovementRequestsService.getAnswers(id)
      setPersonnelMovementRequest(response.data.personnel_movement_request)
      setAnswers(response.data.answers)
      setSteps(response.data.steps)
    } catch {
      toast.error('Erro ao buscar informações da Solicitação de Movimentação de Pessoal!')
    }
  }

  useEffect(() => {
    fetchPersonnelMovementRequest()
  }, [])

  return (
    <>
      {!personnelMovementRequest ? (
        <LoadingBlock size="page" />
      ) : (
        <>
          <VStack align="stretch" spacing={4}>
            <DetailField label="Nome" value={personnelMovementRequest.name} emptyValue="Sem resposta" />
            <DetailField label="E-mail" value={personnelMovementRequest.email} emptyValue="Sem resposta" />
            <DetailField
              label="Setor"
              value={sectors.find((sector) => sector.id === personnelMovementRequest.sector)?.name}
              emptyValue="Sem resposta"
            />
            <DetailField label="Tipo de movimentação" value={personnelMovementRequest.type} emptyValue="Sem resposta" />
          </VStack>

          <Divider my={6} />

          <VStack align="stretch" spacing={4}>
            {steps
              .slice(1)
              .flatMap((step) => step.questions)
              .map((question) => {
                const answerValue = answers.find((answer) => answer.question_id === question.id)?.value

                return (
                  <DetailField
                    key={question.id}
                    label={question.label}
                    value={question.type === 'date' && answerValue ? formatApiDate(answerValue) : answerValue}
                    emptyValue="Sem resposta"
                  />
                )
              })}
            {personnelMovementRequest.descriptive_ok !== null && (
              <DetailField
                label="Descritivo do cargo"
                value={
                  personnelMovementRequest.descriptive_ok ? 'Seguiu com este descritivo' : 'Pediu alterações ao RH'
                }
              />
            )}
            {personnelMovementRequest.descriptive_ok === false && (
              <DetailField label="Alterações pedidas">
                <Text whiteSpace="pre-wrap">{personnelMovementRequest.descriptive_changes}</Text>
              </DetailField>
            )}
          </VStack>
        </>
      )}
    </>
  )
}
